import { storageGetItem, storageRemoveItem, storageSetItem } from "@/utils/utils";

export default class StorageService {
  constructor() {
    this.sharedTableSearchHistory = 'sharedTableSearchHistory'
  }
  getIsActivatedDiscoverCard(discoverCard) {
    const storageData = this.getActivatedDiscoverCardStorage()

    if (storageData) {
      const activatedArr = JSON.parse(storageData)[0].activated

      if (activatedArr.indexOf(discoverCard) > -1) {
        return true
      }
    }
  }
  getActivatedDiscoverCardStorage() {
    return storageGetItem(localStorage, 'DiscoverCard')
  }
  updateActivatedDiscoverCardStorage(discoverCardArr) {
    let JSONData
    let activated
    const storageData = storageGetItem(localStorage, 'DiscoverCard')
    const unique = (arr) => {
      return arr.filter(function(item, index, arr) {
        //当前元素，在原始数组中的第一个索引==当前索引值，否则返回当前元素
        return arr.indexOf(item, 0) === index;
      });
    }
    if (storageData) {
      activated = JSON.parse(storageData)[0].activated
    } else {
      activated = []
    }

    activated = unique([...activated, ...discoverCardArr])
    JSONData = JSON.stringify([{ activated }])
    storageSetItem(localStorage, 'DiscoverCard', JSONData);
  }
  updateSharedTableSearchHistory(searchWord) {
    let sharedTableSearchHistory = storageGetItem(localStorage, this.sharedTableSearchHistory);

    if (searchWord === '') {
      return
    }
    if (sharedTableSearchHistory) {
      let historyLen

      sharedTableSearchHistory = JSON.parse(sharedTableSearchHistory)

      if (sharedTableSearchHistory.indexOf(searchWord) > -1) {
        return
      }

      historyLen = sharedTableSearchHistory.length

      if (historyLen >= 20) {
        sharedTableSearchHistory.splice(historyLen - 1, 1, searchWord)
      } else {
        sharedTableSearchHistory.push(searchWord)
      }
    } else {
      sharedTableSearchHistory = [searchWord]
    }

    storageSetItem(localStorage, this.sharedTableSearchHistory, JSON.stringify(sharedTableSearchHistory))
  }
  getSharedTableSearchHistory() {
    const sharedTableSearchHistory = storageGetItem(localStorage, this.sharedTableSearchHistory)

    if (sharedTableSearchHistory) {
      return JSON.parse(sharedTableSearchHistory)
    }
  }
  clearSharedTableSearchHistory() {
    storageRemoveItem(localStorage, this.sharedTableSearchHistory)
  }
}